
export default {
  name: 'PreloadImage',
}
